/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: roleProfilesActions.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Role Profiles module.
────────────────────────────────────────────────────────────────*/

import type { NavigateFunction } from 'react-router-dom';
import { buildApiUrl, getApiHeaders, API_CONFIG } from '../../config/api';

export const getRoleProfileDuplicateUrl = (id: string | number): string =>
  `/role-profiles/new?duplicate=${id}`;

export const navigateToRoleProfileDuplicate = (
  navigate: NavigateFunction,
  id: string | number,
): void => {
  navigate(getRoleProfileDuplicateUrl(id));
};

export const deleteRoleProfileById = async (
  id: string | number,
  tenantSlug: string,
  userId?: string | number | null,
): Promise<void> => {
  const response = await fetch(
    buildApiUrl(`${API_CONFIG.ENDPOINTS.ROLE_PROFILES}/${id}`),
    {
      method: 'DELETE',
      headers: getApiHeaders(tenantSlug, userId),
    },
  );

  if (!response.ok) {
    let message = 'Failed to delete role profile';
    try {
      const errorData = await response.json();
      if (errorData?.message) {
        message = errorData.message;
      }
    } catch {
      // Ignore JSON parse errors and use default message
    }
    throw new Error(message);
  }
};

